import React, { PureComponent } from 'react';

class ButtonDenegar extends PureComponent {
    constructor(props) {
        super(props);
    }    

    render() {       
        const { denegarCobranza, cobranza } = this.props;     
        return (<a className="clickable none-text-decoration glyphicon glyphicon-remove" aria-hidden="true" onClick={() => this.props.denegarCobranza(cobranza, 6)}></a>);
    }
}

export default ButtonDenegar;